export type DocScrollSnapshot = {
	mode: "anchor";
	pos: number;
	offsetPx: number;
	fallbackScrollTop?: number;
};

export type DocDraft = {
	scroll?: DocScrollSnapshot;
	scrollTop?: number;
};

const drafts = new Map<string, DocDraft>();

export function getDocDraft(key: string): DocDraft | undefined {
	return drafts.get(key);
}

export function setDocDraft(key: string, draft: DocDraft) {
	drafts.set(key, draft);
}

export function clearDocDraft(key: string) {
	drafts.delete(key);
}
